function getMinimumTopPosition() {
  const displayScreenOffset = document.getElementById('displayScreen').getBoundingClientRect().top;
  const displayScreenCenter = document.getElementById('displayScreen').getBoundingClientRect().bottom / 2 - displayScreenOffset / 2;
  const trialTextTop = document.getElementById('trialText').getBoundingClientRect().bottom - displayScreenOffset;

  return trialTextTop < displayScreenCenter ? displayScreenCenter : trialTextTop;
}

function setResponseTopPosition()
{
  const displayScreenOffset = document.getElementById('displayScreen').getBoundingClientRect().top;
  switch (listStimType[trialRow])
  {
    case 1:
        spaceTestResponses = spaceImagesResponses;
        // lastStim -> move input
        // withStim -> move input
        // else do not move (all screens)
        const isResponseWindowWithStim = window.listTrialResponseWindow[window.trialRow]['startPosition'] == 'withStim';
        const isLastStimWithResponseWindow = window.listTrialResponseWindow[window.trialRow]['startPosition'] == 'lastStim' && window.currentScreenIndex == window.listTrialScreensTimings[window.trialRow].length;

        // if responswindow is withStim or lastStim (and on last screen) then we need to use the positioning of this screen
        if (isResponseWindowWithStim || isLastStimWithResponseWindow) {
            // current screen bottom
            let bounds = computeStimuliBounds(
                window.stimuliPositions,
                window.listTrialScreensTimings[window.trialRow][window.currentScreenIndex - 1].startStimuliIndex,
                window.listTrialScreensTimings[window.trialRow][window.currentScreenIndex - 1].stimuliNumber + 1
            );
            bottomTest = bounds.maxBottom;
        } else {
            if (window.maxTrialBottom) {
                bottomTest = window.maxTrialBottom;
            } else {
                bottomTest = parseInt(document.getElementById("image1").style.top,10) + image1height;
            }
        }
      break;
    case 2:
      spaceTestResponses = spaceWordsResponses;
      var lastWordIndex = listNoStim[trialRow] + listNoStimS2[trialRow];
      if(lastWordIndex == 0){
        lastWordIndex = 1;
      }
      const bounds = document.getElementById("word" + lastWordIndex).getBoundingClientRect();
      bottomTest = bounds.bottom - displayScreenOffset;
      break;
    case 3:
      spaceTestResponses = spaceAudioResponses;
      bottomTest = parseInt(document.getElementById("audio1").style.top,10) + audio1height;
      break;
    case 4:
      spaceTestResponses = spaceVideoResponses;
      const video = document.getElementById("video1");
      var videoTop = parseInt(video.style.top,10);
      var videoHeight = parseInt(video.videoHeight*adjuster,10);
      if(video.height) {
        videoHeight = video.height * adjuster;
      }
      if(!videoTop || !videoHeight){
        bottomTest = buttonTopDefault - spaceTestResponses;
      }
      else{
        bottomTest = videoTop + videoHeight;
      }
      break;
    case 5:
      spaceTestResponses = spaceSurveyResponses;
      bottomTest = 600;
      break;
    case 6:
      spaceTestResponses = spaceSurveyResponses;
      bottomTest = 600;
      break;
  }

  if (listStimType[trialRow]==0 || feedbackScreen == 1)//instructions
  {
    currentButtonTop = buttonTopDefault - 50;
    if(feedbackScreen == 1) {
      currentButtonTop -= 50;
    }
  }
  else
  {
    if (columnForTrial('responseType', window.trialRow) == 'sort') {
      const sortableBottom = document.getElementById('responseSortableList').getBoundingClientRect().bottom;
      bottomTest = sortableBottom - displayScreenOffset;
    }

    if(typeof bottomTest !== "undefined" && !isNaN(bottomTest)){
      currentButtonTop = (bottomTest + spaceTestResponses);
    }
    else{
      currentButtonTop = buttonTopDefault - 100;
    }
  }

  currentButtonTop = adjustForText(currentButtonTop);

  var minimumTop = getMinimumTopPosition();
  if(currentButtonTop < minimumTop) {
    currentButtonTop = minimumTop;
  }
}

function adjustForText(topPosition) {
    const textTrialPos = columnForTrial('trialTextPos', trialRow);
    // nothing to do if the position is not bellow because we consider the bottom of the stimuli already
    if (textTrialPos !== 'below') {
        return topPosition;
    }

    const trialTxtHeight = parseInt(document.getElementById('trialText').offsetHeight) || 0;

    return topPosition + trialTxtHeight;
}

function setResponseTopPositionCustomButtons() {
  var position = setResponseTopPosition();
  var $customInputsVisible = customInputsVisible();
  if ($customInputsVisible.length > 0) {
    currentButtonTop += $customInputsVisible.height();
  }
}

function customInputsVisible() {
  return $('#responseBox:visible, #responseComment:visible, #responseContainer:visible');
}


function hasCustomInputsVisible() {
  return $('#responseBox:visible, #responseComment:visible, #responseContainer:visible').length > 0;
}